<template>
  <Info />
</template>

<script>
  import Info from '../../../components/_products/_info/index.vue'
  export default {
    name: "InfoViews",
    components: {
      Info
    } 
  }
</script>